import { BucketFolder } from "../../../utils/Enums";
import { useFileList } from "./useFileList";
import { useFileUpload } from "./useFileUpload";

interface UseFileDropzoneOptions {
    patientId: string;
    folder: BucketFolder | (() => BucketFolder);
    uploadFolder: string | (() => string);
    enabled?: boolean;
    excludePrivate?: boolean;
}

export const useFileDropzone = ({ 
    patientId, 
    folder, 
    uploadFolder, 
    enabled = true,
    excludePrivate = false
}: UseFileDropzoneOptions) => {
    const fileList = useFileList({ patientId, folder, enabled, excludePrivate });
    
    const fileUpload = useFileUpload({
        patientId,
        folder: uploadFolder,
        onSuccess: () => {
            fileList.refreshFiles();
        },
        onError: (error) => {
            console.error("Upload error:", error);
        }
    });

    return {
        // File list properties
        files: fileList.files,
        isLoading: fileList.isLoading,
        error: fileList.error,
        refreshFiles: fileList.refreshFiles,
        
        // File upload properties
        uploadedFile: fileUpload.uploadedFile,
        isUploading: fileUpload.isUploading,
        onFileSelect: fileUpload.onFileSelect,
        onFileRemove: fileUpload.onFileRemove,
        uploadFile: fileUpload.uploadFile
    };
}; 